import React, { Component } from "react";

import "./index.scss";

export default class Loading extends Component {
	render() {
		return <div className="loading-component center" />;
	}
}